import React, { useEffect, useRef } from 'react'
import { TamaguiElement } from 'tamagui'

import { Spinner } from './Spinner'

/**
 * Sentinel component that auto-loads more items when scrolled into view.
 * Uses IntersectionObserver to detect visibility and triggers `loadNext`.
 * Renders a Spinner while waiting for the next page.
 */
export const AutoLoadMore = ({
  hasNext,
  loadNext,
  count,
}: {
  hasNext: boolean
  loadNext: (count: number) => void
  count: number
}) => {
  const sentinelRef = useRef<TamaguiElement>(null)

  useEffect(() => {
    const el = sentinelRef.current

    if (
      !el ||
      !hasNext ||
      typeof window === 'undefined' ||
      !window.IntersectionObserver
    ) {
      return
    }

    const observer = new window.IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        loadNext(count)
      }
    })

    observer.observe(el as unknown as Element)

    return () => {
      observer.disconnect()
    }
  }, [sentinelRef.current, hasNext, loadNext, count])

  if (!hasNext) return null

  return (
    <Spinner
      ref={sentinelRef as React.Ref<any>}
      size='$9'
      color='$primaryColor'
    />
  )
}
